import React from 'react'
import { useStaticQuery, graphql } from 'gatsby'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
// Component imports
import { Page as Loading } from 'components/Loading'

import * as actions from '../actions'
import * as selectors from '../selectors'

/**
 */
const DefaultLoading = () => <Loading>Loading ColorSelections...</Loading>

/**
 */
const ReduxInitializer = connect(
  // mapStateToProps
  (state) => ({
    isInitialized: selectors.selectIsInitialized(state),
  }),
  // mapDispatchToProps
  (dispatch) =>
    bindActionCreators(
      {
        init: actions.init,
      },
      dispatch,
    ),
)(
  // BaseComponent
  class extends React.Component {
    componentDidMount = () => {
      const { init, data, isInitialized } = this.props

      if (!isInitialized) {
        // dispatch init
        init(data)
      }
    }

    render = () => {
      const {
        children,
        isInitialized,
        renderers: { Loading = DefaultLoading },
      } = this.props

      if (!isInitialized) {
        return <Loading />
      }

      return <>{children}</>
    }
  },
)

/**
 * Initializer to load all plans from graphql and initialize redux
 */
export const Initializer = ({ children, ...props }) => {
  const data = useStaticQuery(graphql`
    query ColorsInitializeQuery {
      colors: allColorsYaml {
        nodes {
          id
          label
          #cost
          colors {
            background
            font
          }
        }
      }
    }
  `)

  return (
    <ReduxInitializer data={data.colors.nodes} {...props}>
      {children}
    </ReduxInitializer>
  )
}
